import React, { FunctionComponent } from "react";
import Lottie from "react-lottie";

interface IProps {
    animationData: object;
    width: number;
    height: number;
}

const LottieAnimation: FunctionComponent<IProps> = ({
    animationData,
    width,
    height,
}) => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };
    return <Lottie options={defaultOptions} height={height} width={width} />;
};

export default LottieAnimation;
